import React from 'react';
import {I18n} from "react-redux-i18n";

const FileUploader = ({
    allowedExtensions,
    onFileUploaded,
    handleWrongFileFormat,
    allowedFiles,
    style,
    placeholder,
    error
}) => {
    const classNames = "btn btn-primary react-bs-table-csv-btn hidden-print";
    return <div style={{display: 'inline-block'}}>
        <input type="file" id="fileUploader" accept={allowedFiles} className="input-file-hide" onChange={e => updateNewFile(allowedExtensions, onFileUploaded, handleWrongFileFormat, e)}/>
        <label htmlFor={"fileUploader"} className={classNames} style={style ? style : {}}>
            {placeholder ?
                placeholder :
                I18n.t('fields.placeholder')
            }
        </label>
        <div className="error-text" style={{textAlign: "left", float: "none"}}>
            {error}
        </div>
    </div>;
};

function updateNewFile(allowedExtensions, onFileUploaded, handleWrongFileFormat, e) {
    e.preventDefault();
    let uploadedFile = e.target.files[0];
    let fileIsAllowed = true;
    if(allowedExtensions) {
        fileIsAllowed = fileExtensionInAllowedExtensions(uploadedFile, allowedExtensions);
    }
    if(fileIsAllowed) {
        handleUploadFile(onFileUploaded, uploadedFile);
    } else {
        handleWrongFileFormat();
    }
    document.getElementById("fileUploader").value = "";
}

function fileExtensionInAllowedExtensions(uploadedFile, allowedExtensions) {
    let fileExtension = getFileExtension(uploadedFile);
    return allowedExtensions.indexOf(fileExtension) > -1;
}

function getFileExtension(file) {
    let fileKeywords = file.name.split(".");
    return fileKeywords[fileKeywords.length - 1];
}

function handleUploadFile(onFileUploaded, uploadedFile) {
    let onFileUpload = onFileUploaded ? onFileUploaded : () => {};
    let reader = new FileReader();
    reader.onloadend = () => {
        onFileUpload(uploadedFile, reader.result);
    };
    reader.readAsDataURL(uploadedFile);

}

export default FileUploader;